import styled from "styled-components";

export const Container = styled.div`
  padding: 1rem;
  background: ${props => props.theme.colors.danger};
  color: ${props => props.theme.colors.buttonText};
  border-radius: .25rem;
  margin-top: 1rem;
`;
